import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import qs from "query-string";
import StaticBarModel from "../../models/static-bar";

export default class StaticBarRepository extends BaseRepository {
  static modelClass = StaticBarModel;
  modelName = "static-bar";

  async query(params) {
    let otherThanCaseIdParams = {};
    for (let key in params) {
      if (key !== "caseId") {
        otherThanCaseIdParams[key] = params[key];
      }
    }
    return await super.query({
      urlPath: `case/${params.caseId}/static_bar/?` + qs.stringify(otherThanCaseIdParams),
    });
  }
}
